import { useTranslation } from 'react-i18next'
import { ConfirmDialog } from '@/components/confirm-dialog'

export type PendingSupplierInstallationEmissionReportDelete = {
  id: string
  label: string
}

type SupplierInstallationEmissionReportDeleteConfirmDialogProps = {
  pendingDelete: PendingSupplierInstallationEmissionReportDelete | null
  open: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
  isLoading?: boolean
}

export function SupplierInstallationEmissionReportDeleteConfirmDialog({
  pendingDelete,
  open,
  onOpenChange,
  onConfirm,
  isLoading = false,
}: SupplierInstallationEmissionReportDeleteConfirmDialogProps) {
  const { t } = useTranslation(['installations', 'common'])

  if (!pendingDelete) {
    return null
  }

  return (
    <ConfirmDialog
      open={open}
      onOpenChange={onOpenChange}
      title={t(
        'installations:suppliers.edit.installations.edit.emissionReports.deleteConfirm.title'
      )}
      desc={t(
        'installations:suppliers.edit.installations.edit.emissionReports.deleteConfirm.description',
        { label: pendingDelete.label }
      )}
      cancelBtnText={t('common:actions.cancel')}
      confirmText={t('common:actions.delete')}
      destructive
      isLoading={isLoading}
      handleConfirm={onConfirm}
    />
  )
}
